
import { ActionTree } from 'vuex'
import axios, {AxiosResponse, AxiosError} from "axios";
import * as moment from 'moment';

export const actions: ActionTree<any, any> = {

    /**
     * Get list of locales
     *
     * @param {any} state
     * @param {any} getters
     * @param {any} commit
     * @param {any} dispatch
     * @param {any} rootState
     * @returns {any}
     */

    getLocales: ({state, getters, commit, dispatch, rootState}, force) => {

        if (force) commit('resetLocalesCache');

        // Pull from store if loaded and cache hasn't expired
        if (state.localesExpire && moment().isBefore(state.localesExpire)) {
            return state.locales;
        }

        commit('setLocalesLoading', true);

        return new Promise((resolve, reject) => {

            axios.get('/locales')

                .then(({data}) => {

                    commit('setLocales', data.locales);
                    commit('setLocalesLoading', false);
                    resolve(null);
                })
                .catch(error => {

                    commit('setLocalesLoading', false);
                    reject(error);
                });
        });
    },
};
